import { applyMiddleware, createStore } from 'redux';
import thunk from 'redux-thunk';
import promise from 'redux-promise-middleware';
import rootReducer from './rootReducer';
import { composeWithDevTools } from 'redux-devtools-extension'

const middleware = applyMiddleware(thunk, promise);
let store;

if (process.env.NODE_ENV === "production") {
    store = createStore(rootReducer, {}, middleware);
} else {
    store = createStore(rootReducer, {}, composeWithDevTools(middleware));
}
export default store;